import { createApiSlice } from "@common/common-slice/commonSlice";

import { GET_DOMAIN_BY_INDUSTRY } from "@routes";

const apiConfig = [
  {
    name: "getDomain",
    method: "get",
    url: GET_DOMAIN_BY_INDUSTRY,
    stateKey: "domainData",
  },
];

const customReducers = {
  initialState: {
    domainData: [],
    selectedData: {},
  },
  reducers: {
  },
};

const { slice, thunks, actions } = createApiSlice(
  "domain",
  apiConfig,
  customReducers
);

const domainSlice = slice;

export default domainSlice.reducer;

export const actionsExports = actions;

export const {
  getDomain,
} = thunks;